import { render } from "./TreatmentChart.vue?vue&type=template&id=871c88da"
import script from "./TreatmentChart.vue?vue&type=script&lang=js"
export * from "./TreatmentChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__